(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-product"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.dogoRestockCardsInitialized) return;
    window.dogoRestockCardsInitialized = true;

    function appButton(card) {
      return card.querySelector('.email-me-inlineButton');
    }

    function syncCard(card) {
      var button = appButton(card);
      if (!button) return;

      var label = card.dataset.restockLabel;
      if (button.textContent.trim() !== label) button.textContent = label;
      if (button.getAttribute('aria-label') !== label) button.setAttribute('aria-label', label);
      if (button.tabIndex !== -1) button.tabIndex = -1;

      var appControl = button.closest('.product-restore-email');
      if (appControl && appControl.getAttribute('aria-hidden') !== 'true') {
        appControl.setAttribute('aria-hidden', 'true');
      }

      var trigger = card.querySelector('[data-restock-card-trigger]');
      if (trigger && trigger.hidden) trigger.hidden = false;
    }

    function syncCards() {
      document.querySelectorAll('[data-restock-card]').forEach(syncCard);
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-restock-card-trigger]');
      if (!trigger) return;
      event.preventDefault();

      var card = trigger.closest('[data-restock-card]');
      var status = card.querySelector('[data-restock-card-status]');
      var attempts = 0;
      trigger.setAttribute('aria-busy', 'true');
      if (status) status.textContent = card.dataset.restockLoading;

      function openForm() {
        var button = appButton(card);
        if (button) {
          trigger.removeAttribute('aria-busy');
          if (status) status.textContent = '';
          button.click();
          return;
        }

        attempts += 1;
        if (attempts < 40) {
          window.setTimeout(openForm, 200);
          return;
        }

        trigger.removeAttribute('aria-busy');
        if (status) status.textContent = card.dataset.restockError;
      }

      openForm();
    });

    new MutationObserver(syncCards).observe(document.body, {
      attributes: true,
      childList: true,
      subtree: true
    });
    syncCards();
  })();
  } catch(e) { console.error(e); }
})();

})();
